import React from "react"
import dayjs from "dayjs"
import CoreZoneLayer from "@/features/gis/CoreZoneLayer.jsx"
import { zoneValueLabel } from "@/utils/zoneLabels.js"

const STYLE = { fillColor: "#0277bd", color: "#0277bd", weight: 2 }

const season = (months) => {
  if (!Array.isArray(months)) return null
  const valid = [...new Set(months.filter((m) => Number.isInteger(m) && m >= 1 && m <= 12))]
  if (valid.length === 0 || valid.length === 12) return null
  return valid.map((m) => dayjs().month(m - 1).format("MMM")).join(", ")
}

const rows = (p) => {
  const s = season(p.valid_months)
  return [
    p.name && [null, p.name],
    p.risk_type && ["Risk", zoneValueLabel(p.risk_type)],
    s && ["Season", s],
    p.info && ["Info", p.info],
    p.as_of && ["As of", p.as_of],
  ]
}

export default function OperationalRisk(props) {
  return (
    <CoreZoneLayer
      flag="OperationalRisk"
      path="custom-areas"
      title="Operational Risk Area"
      style={STYLE}
      rows={rows}
      {...props}
    />
  )
}
